/* ============================================================
   BUNDLE PRODUCT PAGE — LOGIC (matches reference layout)
   Vanilla JS. Uses Shopify AJAX Cart API (/cart/add.js).

   FREE GIFT VARIANT ID
   -----------------------------------
   Read from the section's data-free-variant-id attribute,
   which is set ONCE in Theme Editor → this section →
   "Free Gift Settings → Free Gift Variant ID".
   Fallback constant below is only used if that setting is
   left blank.
   ============================================================ */
window.BUNDLE_FREE_VARIANT_ID_FALLBACK = "REPLACE_WITH_FREE_VARIANT_ID";

(function () {
  'use strict';

  function BundleInstance(root) {
    this.root = root;
    this.maxSelect = parseInt(root.dataset.maxSelect, 10) || 2;
    this.freeVariantId = (root.dataset.freeVariantId || window.BUNDLE_FREE_VARIANT_ID_FALLBACK || '').trim();
    this.freeGiftTitle = root.dataset.freeGiftTitle || 'Free Gift';
    this.freeGiftImage = root.dataset.freeGiftImage || '';
    this.cartAddUrl = root.dataset.cartAddUrl || '/cart/add.js';
    this.cartUrl = root.dataset.cartUrl || '/cart';
    this.checkoutUrl = root.dataset.checkoutUrl || '/checkout';
    this.ctaDestination = root.dataset.ctaDestination || 'checkout';
    this.currencySymbol = root.dataset.currencySymbol || '';

    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));
    this.progressText = root.querySelector('[data-progress-text]');
    this.thumbsWrap = root.querySelector('[data-bundle-thumbs]');
    this.totalEl = root.querySelector('[data-selected-total]');
    this.ctaBtn = root.querySelector('[data-bundle-cta]');
    this.ctaLabel = root.querySelector('[data-cta-label]');
    this.ctaSpinner = root.querySelector('[data-cta-spinner]');
    this.toast = root.querySelector('[data-bundle-toast]');

    // Map: variantId -> { qty, price, title, image }
    this.selections = {};

    this.bindEvents();
    this.render();

    if (!this.freeVariantId || this.freeVariantId.indexOf('REPLACE') === 0) {
      console.warn('[Bundle] No Free Gift Variant ID configured. Set it in Theme Editor → this section → "Free Gift Settings".');
    }
  }

  BundleInstance.prototype.bindEvents = function () {
    var self = this;

    this.cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-add-btn]');
      var stepper = card.querySelector('[data-stepper]');
      var incBtn = card.querySelector('[data-increment]');
      var decBtn = card.querySelector('[data-decrement]');

      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        self.setQty(card, 1);
      });

      incBtn.addEventListener('click', function () {
        var current = self.getQty(card);
        self.setQty(card, current + 1);
      });

      decBtn.addEventListener('click', function () {
        var current = self.getQty(card);
        self.setQty(card, current - 1);
      });
    });

    this.ctaBtn.addEventListener('click', function () {
      self.addBundleToCart();
    });
  };

  BundleInstance.prototype.getQty = function (card) {
    var variantId = card.dataset.variantId;
    return (this.selections[variantId] && this.selections[variantId].qty) || 0;
  };

  BundleInstance.prototype.totalSelectedQty = function () {
    var self = this;
    return Object.keys(this.selections).reduce(function (sum, id) {
      return sum + self.selections[id].qty;
    }, 0);
  };

  BundleInstance.prototype.setQty = function (card, newQty) {
    var variantId = card.dataset.variantId;
    var currentTotal = this.totalSelectedQty();
    var currentQty = this.getQty(card);
    var delta = newQty - currentQty;

    if (newQty < 0) newQty = 0;

    if (delta > 0 && currentTotal + delta > this.maxSelect) {
      return;
    }

    if (newQty === 0) {
      delete this.selections[variantId];
    } else {
      this.selections[variantId] = {
        qty: newQty,
        price: parseInt(card.dataset.productPrice, 10) || 0,
        title: card.dataset.productTitle || '',
        image: card.dataset.productImage || ''
      };
    }

    this.render();
  };

  BundleInstance.prototype.render = function () {
    var self = this;
    var totalQty = this.totalSelectedQty();
    var complete = totalQty >= this.maxSelect;

    this.progressText.classList.toggle('is-complete', complete);
    this.progressText.textContent = complete
      ? 'Free Gift Unlocked \uD83C\uDF89'
      : 'Select ' + (totalQty + 1) + ' of ' + this.maxSelect + ' Products';

    this.cards.forEach(function (card) {
      var variantId = card.dataset.variantId;
      var qty = self.getQty(card);
      var addBtn = card.querySelector('[data-add-btn]');
      var stepper = card.querySelector('[data-stepper]');
      var qtyDisplay = card.querySelector('[data-qty-display]');
      var incBtn = card.querySelector('[data-increment]');
      var decBtn = card.querySelector('[data-decrement]');
      var isSelected = qty > 0;

      card.classList.toggle('is-selected', isSelected);

      if (isSelected) {
        addBtn.hidden = true;
        stepper.hidden = false;
        qtyDisplay.value = qty;
        incBtn.disabled = totalQty >= self.maxSelect;
      } else {
        addBtn.hidden = false;
        stepper.hidden = true;
        addBtn.disabled = totalQty >= self.maxSelect;
      }

      card.classList.toggle('is-disabled', !isSelected && totalQty >= self.maxSelect);
    });

    this.renderThumbs(complete);

    var total = Object.keys(this.selections).reduce(function (sum, id) {
      var item = self.selections[id];
      return sum + (item.price * item.qty);
    }, 0);
    this.totalEl.textContent = this.formatMoney(total);

    this.ctaBtn.disabled = !complete;
  };

  BundleInstance.prototype.renderThumbs = function (complete) {
    var self = this;
    this.thumbsWrap.innerHTML = '';

    Object.keys(this.selections).forEach(function (variantId) {
      var item = self.selections[variantId];
      var thumb = document.createElement('div');
      thumb.className = 'bundle-thumb';
      thumb.dataset.variantId = variantId;

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'bundle-thumb__remove';
      removeBtn.innerHTML = '&times;';
      removeBtn.setAttribute('aria-label', 'Remove ' + item.title);
      removeBtn.addEventListener('click', function () {
        var card = self.cards.find(function (c) { return c.dataset.variantId === variantId; });
        if (card) self.setQty(card, 0);
      });

      var img = document.createElement('img');
      img.src = item.image;
      img.alt = item.title;

      var qtyBadge = document.createElement('span');
      qtyBadge.className = 'bundle-thumb__qty';
      qtyBadge.textContent = 'x' + item.qty;

      thumb.appendChild(removeBtn);
      thumb.appendChild(img);
      thumb.appendChild(qtyBadge);
      self.thumbsWrap.appendChild(thumb);
    });

    if (complete) {
      var freeThumb = document.createElement('div');
      freeThumb.className = 'bundle-thumb bundle-thumb--free';

      var lock = document.createElement('span');
      lock.className = 'bundle-thumb__lock';
      lock.textContent = '\uD83D\uDD12';
      lock.title = 'Automatically added — cannot be changed or removed';

      var img = document.createElement('img');
      img.src = this.freeGiftImage;
      img.alt = this.freeGiftTitle;

      var qtyBadge = document.createElement('span');
      qtyBadge.className = 'bundle-thumb__qty';
      qtyBadge.textContent = 'FREE';

      freeThumb.appendChild(lock);
      freeThumb.appendChild(img);
      freeThumb.appendChild(qtyBadge);
      this.thumbsWrap.appendChild(freeThumb);
    }
  };

  BundleInstance.prototype.formatMoney = function (cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return (this.currencySymbol || '') + (cents / 100).toFixed(2);
  };

  BundleInstance.prototype.addBundleToCart = function () {
    var self = this;

    if (this.totalSelectedQty() < this.maxSelect) return;

    if (!this.freeVariantId || this.freeVariantId.indexOf('REPLACE') === 0) {
      this.showToast('Bundle is not fully configured yet. Please set the Free Gift Variant ID.');
      return;
    }

    var items = Object.keys(this.selections).map(function (variantId) {
      return { id: variantId, quantity: self.selections[variantId].qty };
    });

    items.push({
      id: this.freeVariantId,
      quantity: 1,
      properties: {
        '_bundle_free_gift': 'true',
        '_bundle_source': 'buy-2-get-1-free'
      }
    });

    this.setLoading(true);

    fetch(this.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add bundle to cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        self.onAddSuccess();
      })
      .catch(function (err) {
        self.setLoading(false);
        self.showToast(err.message || 'Something went wrong. Please try again.');
      });
  };

  BundleInstance.prototype.onAddSuccess = function () {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    if (this.ctaDestination === 'checkout') {
      window.location.href = this.checkoutUrl;
      return;
    }

    if (this.ctaDestination === 'drawer') {
      var drawer =
        document.querySelector('cart-drawer') ||
        document.querySelector('[data-cart-drawer]') ||
        document.querySelector('#CartDrawer');
      if (drawer) {
        this.setLoading(false);
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('is-open', 'active');
        }
        this.showToast('Bundle added! Your free gift is in the cart. \uD83C\uDF81');
        return;
      }
    }

    window.location.href = this.cartUrl;
  };

  BundleInstance.prototype.setLoading = function (isLoading) {
    this.ctaBtn.disabled = isLoading || this.totalSelectedQty() < this.maxSelect;
    this.ctaSpinner.hidden = !isLoading;
    this.ctaLabel.hidden = isLoading;
  };

  BundleInstance.prototype.showToast = function (message) {
    var self = this;
    this.toast.textContent = message;
    this.toast.hidden = false;
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(function () {
      self.toast.hidden = true;
    }, 3200);
  };

  window.BundleBuilder = {
    init: function (root) {
      if (!root || root._bundleInitialized) return;
      root._bundleInitialized = true;
      new BundleInstance(root);
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bundle-section]').forEach(function (root) {
      window.BundleBuilder.init(root);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-bundle-section]');
    if (root) window.BundleBuilder.init(root);
  });
})();